import { render } from "./ProjectDetail.vue?vue&type=template&id=41987fc2"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
script.render = render

export default script